import React, { Fragment } from 'react';
import App from 'next/app';
import withData from 'lib/withData';
import { ApolloProvider } from 'react-apollo';
import { Provider } from 'react-redux';
import DefaultMetadata from 'components/DefaultMetadata';
import LazyAssetRenderer from 'components/LazyAssetRenderer';
import Webfont from 'components/Webfont';
import PreviewWarning from 'components/PreviewWarning';
// CSS can ONLY be imported into _app (see https://github.com/vercel/next.js/blob/master/errors/css-global.md)
import 'oxygen-lib-ui/components/EmailSignupFormConfirmation/index.scss';
import 'components/ActionIcon/index.scss';
import 'components/Ad/index.scss';
import 'components/App/index.scss';
import 'components/Checkbox/index.scss';
import 'components/CollectionLayout/index.scss';
import 'components/ContentBundle/index.scss';
import 'components/EmailSignup/index.scss';
import 'components/Figure/index.scss';
import 'components/Recirc/index.scss';
import 'components/SiteFooter/index.scss';
import 'components/Sitemap/index.scss';
import 'components/SitePostBundle/index.scss';
import 'components/SitePostLayout/index.scss';
import 'components/SiteRecipe/index.scss';
import 'components/SpreadBundle/index.scss';
import 'components/Teaser/index.scss';
import 'components/UserAuthErrorMessage/index.scss';
import 'components/Video/index.scss';
import 'components/VideoPlaylist/index.scss';
// Required by GiftGuideFilters
import 'react-input-range/src/scss/index.scss';
import { baseFontSize } from 'styles/css-constants';

class CustomApp extends App {
  static async getInitialProps({ Component, ctx }) {
    let pageProps = {};

    if (Component.getInitialProps) {
      pageProps = await Component.getInitialProps(ctx);
    }

    return { pageProps };
  }
  componentDidMount() {
    // Register service worker
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.register('/sw.js');
    }
  }
  render() {
    const {
      Component,
      pageProps,
      apollo,
      redux,
      ctx,
      router,
      statusCode
    } = this.props;

    const isPreview = router && router.query && router.query.preview === 'true';

    return (
      <ApolloProvider client={apollo}>
        <Provider store={redux}>
          <Fragment>
            <Webfont />
            <DefaultMetadata />
            <LazyAssetRenderer />
            {isPreview && <PreviewWarning path={router.asPath} />}
            <Component ctx={ctx} statusCode={statusCode} {...pageProps} />
          </Fragment>
        </Provider>
        <style jsx global>{`
          :root {
            --baseFontSize: ${baseFontSize};
            --fontMultiplier: 1.125;
            --fontMultiplierNeg: 1.25;
          }

          @media (min-width: 64em) {
            :root {
              --fontMultiplier: 1.25;
              --fontMultiplierNeg: 1.125;
            }
          }

          :root {
            --fontScale1: calc(var(--baseFontSize) * var(--fontMultiplier));
            --fontScale2: calc(var(--fontScale1) * var(--fontMultiplier));
            --fontScale3: calc(var(--fontScale2) * var(--fontMultiplier));
            --fontScale4: calc(var(--fontScale3) * var(--fontMultiplier));
            --fontScale5: calc(var(--fontScale4) * var(--fontMultiplier));
            --fontScale6: calc(var(--fontScale5) * var(--fontMultiplier));
            --fontScale7: calc(var(--fontScale6) * var(--fontMultiplier));
            --fontScale8: calc(var(--fontScale7) * var(--fontMultiplier));
            --fontScale9: calc(var(--fontScale8) * var(--fontMultiplier));
            --fontScaleNeg1: calc(var(--baseFontSize) / var(--fontMultiplier));
            --fontScaleNeg2: calc(var(--fontScaleNeg1) / var(--fontMultiplier));
            --fontScaleNeg3: calc(var(--fontScaleNeg2) / var(--fontMultiplier));
            --fontScaleNeg4: calc(var(--fontScaleNeg3) / var(--fontMultiplier));
            --fontScaleNeg5: calc(var(--fontScaleNeg4) / var(--fontMultiplier));
          }
        `}</style>
      </ApolloProvider>
    );
  }
}

export default withData(CustomApp);
